import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../../api/auth';

const ChildrenSchedule = () => {
  const [children, setChildren] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchChildren();
  }, []);

  const fetchChildren = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await api.get('/parent/children', {
        headers: { Authorization: `Bearer ${token}` }
      });
      const list = Array.isArray(res.data) ? res.data : (res.data.children || res.data.data || []);
      setChildren(list);
    } catch (err) {
      console.error('Erreur:', err);
      setChildren([]);
    } finally {
      setLoading(false);
    }
  };

  const colors = ['bg-[#3B82F6]', 'bg-[#22C55E]', 'bg-[#A855F7]', 'bg-[#F39C12]'];

  return (
    <div className="p-6 lg:p-8 bg-white min-h-screen">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-[#0A0A0A]">🕐 Emploi du temps</h1>
        <p className="text-gray-500 mt-1">Sélectionnez un enfant pour voir son emploi du temps</p>
      </div>

      {loading ? (
        <div className="text-center py-20 text-gray-500">Chargement...</div>
      ) : children.length === 0 ? (
        <div className="bg-white rounded-2xl border border-gray-100 p-12 text-center">
          <p className="text-5xl mb-3">📭</p>
          <p className="text-lg font-bold text-[#0A0A0A] mb-2">Aucun enfant enregistré</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {children.map((child, idx) => (
            <Link
              key={child.id}
              to={`/parent/children/${child.id}/schedule`}
              className="bg-white rounded-2xl border border-gray-100 p-5 hover:shadow-lg hover:border-[#F39C12]/30 transition group"
            >
              <div className="flex items-center gap-4 mb-3">
                <div className={`w-14 h-14 rounded-full ${colors[idx % colors.length]} flex items-center justify-center text-white font-bold text-lg flex-shrink-0`}>
                  {child.name?.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase() || '👦'}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-bold text-[#0A0A0A] truncate">{child.name}</p>
                  <p className="text-xs text-gray-500">{child.class_name || 'Classe non assignée'}</p>
                </div>
                <span className="text-gray-400 group-hover:text-[#F39C12] group-hover:translate-x-1 transition">
                  →
                </span>
              </div>
              <p className="text-xs text-[#F39C12] font-medium">
                Voir l'emploi du temps →
              </p>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default ChildrenSchedule;